<template>
  <div class="chartAlign">
    <div :style="{ height: screen_height + 'px' }">
      <v-chart
        class="performanceChart"
        :option="graph_options"
        autoresize
        :ref="chart_ref"
        :id="chart_id"
      ></v-chart>
    </div>
  </div>
</template>

<script>
import VChart, { THEME_KEY } from "vue-echarts";
import "echarts";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import {
  PERFORMANCE_AXIS_LABEL,
  PERFORMANCE_AXIS_LINE,
  PERFORMANCE_AXIS_NAME,
  PERFORMANCE_CHART_COLORS,
  PERFORMANCE_LEGEND_TEXT,
  PERFORMANCE_SPLIT_LINE,
} from "./performanceChartStyle.js";

use([
  CanvasRenderer,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

export default {
  name: "TimeSeriesGraph",
  props: ["graph_data", "screen_height", "chart_ref", "chart_id"],
  components: {
    VChart,
  },
  provide: {
    [THEME_KEY]: "light",
  },
  computed: {
    graph_options: function () {
      let dataset = this.graph_data;
      let data_category = [];
      let data_series = [];
      let data = [];
      let series = [];

      if (dataset != null && dataset.length > 0) {
        data = Array.from(Array(dataset[0].length - 1), () => []);
        data_series = dataset[0].slice(1);

        for (let i = 1; i < dataset.length; i++) {
          data_category.push(dataset[i][0]);

          for (let j = 1; j < dataset[i].length; j++) {
            data[j - 1].push(dataset[i][j]);
          }
        }

        for (let idx = 0; idx < data.length; idx++) {
          series.push({
            name: data_series[idx],
            type: "line",
            showSymbol: false,
            stack: "total",
            areaStyle: {},
            data: data[idx],
            emphasis: {
              focus: "series",
            },
          });
        }
      }

      return {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(15, 23, 42, 0.92)",
          borderWidth: 0,
          textStyle: {
            color: "#ffffff",
            fontFamily: "Poppins",
            fontSize: 13,
          },
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#475569",
            },
          },
        },
        legend: {
          data: data_series,
          type: "scroll",
          top: 0,
          itemHeight: 10,
          itemWidth: 18,
          textStyle: PERFORMANCE_LEGEND_TEXT,
        },
        grid: {
          left: "3%",
          right: "0%",
          bottom: "5%",
          top: 42,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: data_category,
          axisLine: PERFORMANCE_AXIS_LINE,
          axisTick: {
            alignWithLabel: true,
            lineStyle: {
              color: "#cbd5e1",
            },
          },
          axisLabel: PERFORMANCE_AXIS_LABEL,
        },
        yAxis: {
          name: "Contribution ($)",
          nameTextStyle: PERFORMANCE_AXIS_NAME,
          nameLocation: 'middle',
          nameGap: 58,
          type: "value",
          axisLine: PERFORMANCE_AXIS_LINE,
          splitLine: PERFORMANCE_SPLIT_LINE,
          axisLabel: {
            ...PERFORMANCE_AXIS_LABEL,
            formatter: function (value) {
              if (value >= 1e9) return "$" + (value / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
              if (value >= 1e6) return "$" + (value / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
              if (value >= 1e3) return "$" + (value / 1e3).toFixed(1).replace(/\.0$/, "") + "K";
              return "$" + value.toFixed(1);
            },
          },
        },
        series: series,
        color: PERFORMANCE_CHART_COLORS,
      };
    },
  },
};
</script>

<style scoped>
.performanceChart {
  height: 100%;
  width: 100%;
}

.chartAlign {
  margin: auto 0;
  width: 100%;
}
</style>
